<template>
  <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Content</strong> Form
          </div>
          <b-form v-on:submit.prevent="submitFile()" class="content-form">
            <b-form-group
              label="Title"
              label-for="title"
              description=""
              label-size="sm"
              label-text-align="right"
              :label-cols="2"
              :horizontal="true">
              <b-form-textarea
                id="title"
                v-model="data.title"
                placeholder=""
                rows="2"
                max-rows="2"
                required
              ></b-form-textarea>
            </b-form-group>

            <div id="" role="group"  class="b-form-group form-group">
                <div class="form-row">
                  <label id="" for="category" class="col-sm-2 col-form-label col-form-label-sm text-right" >Category</label>
                  <div class="col-md-4">
                    <select  class="form-control form-control-sm custom-select custom-select-sm" v-model="data.category" required @change="getCategorySub">
                      <option  v-for="item in options.category"  :value="item.id">{{item.name}}</option>
                    </select>
                  </div>
                  <label id="" for="category" class="col-sm-2 col-form-label col-form-label-sm text-right">Sub Category</label>
                  <div class="col-md-4">
                      <select  class="form-control form-control-sm custom-select custom-select-sm" v-model="data.category_sub">
                            <option  v-for="item in options.category_sub"  :value="item.id">{{item.name}}</option>
                      </select>
                    </div>
                  </div>

                </div>
            </div>
            <b-form-group
              label="Cover Type"
              label-for="category"
              description=""
              label-size="sm"
              label-text-align="right"
              :label-cols="2"
              :horizontal="true">
              <b-form-select v-model="data.type" size="sm" class="" required @change="changeType" >
                <option  v-for="item in options.type"  :value="item.val">{{item.name}}</option>
              </b-form-select>
            </b-form-group>

            <b-form-group
              label="Picture"
              label-for="picture"
              description=""
              label-size="sm"
              label-text-align="right"
              :label-cols="2"
              v-if="data.type=='article'"
              :horizontal="true">
              <div>
                <b-button-group>
                  <b-button size="sm" @click="$refs.file.click()" variant="outline-primary">Upload Image</b-button>
                  <b-button size="sm" variant="outline-success" @click="selectImage">Select Image</b-button>
                  <input type="file" ref="file" @change="onFileChange" accept="image/*" style="display: none">
                </b-button-group>
              </div>
              <div style="margin:2rem 0rem">
                <img :src="data.img_prev" style="width:100%" />
              </div>
            </b-form-group>

            <b-form-group
              label="Picture"
              label-for="picture"
              description=""
              label-size="sm"
              label-text-align="right"
              :label-cols="2"
              v-if="data.type=='galery'"
              :horizontal="true">
              <div>
                <b-button-group>
                  <b-button size="sm" @click="$refs.files.click()" variant="outline-primary">Upload Image</b-button>
                  <input type="file" ref="files" multiple="multiple" @change="onFilesChange" accept="image/*" style="display: none">
                </b-button-group>
              </div>
              <div style="margin:2rem 0rem" >
                <div class="row">
                  <div class="col-md-4" v-for="(item,i) in data.galeries">
                    <div style="padding:5px;">
                      <i class="fa fa-times" @click="removeGaleries(i)"></i>
                      <img :src="item.img_prev" style="width:100%;" />
                    </div>
                  </div>
                </div>
              </div>
            </b-form-group>

            <b-form-group
              label="Embed Youtube"
              label-for="photographer"
              label-text-align="right"
              description=""
              :label-cols="2"
              v-if="data.type=='video'"
              :horizontal="true">
              <b-form-input id="video" type="text"  autocomplete="video" class="form-control-warning" v-model="data.video"></b-form-input>  
              <div style="margin:20px 0px;">
                <iframe 
                  v-if="data.video"
                  width="100%"
                  height="480"
                  :src="data.video"
                  frameborder="0"
                  gesture="media"
                  allowfullscreen></iframe>
              </div>
            </b-form-group>

            <b-form-group
              label="Submer Foto"
              label-for="photographer"
              label-text-align="right"
              description=""
              :label-cols="2"
              :horizontal="true">
              <b-form-input id="photographer" type="text"  autocomplete="photographer" class="form-control-warning" v-model="data.photographer"></b-form-input>              
            </b-form-group>
            <b-form-group
              label="Content"
              label-for="content"
              description=""
              label-size="sm"
              label-text-align="right"
              :label-cols="2"
              :horizontal="true">
              <vue-editor v-model="data.content" :editorToolbar="customToolbar"></vue-editor>
            </b-form-group>

            <b-form-group
              label="Tags"
              label-for="tags"
              description=""
              label-size="sm"
              label-text-align="right"
              :label-cols="2"
              :horizontal="true">

              <vue-tags-input
                v-model="data.tag"
                :tags="data.tags"
                class="from-control"
                @tags-changed="newTags => data.tags = newTags"
              />
            </b-form-group>

            <b-form-group
              label="Status"
              label-for="picture"
              description=""
              label-size="sm"
              label-text-align="right"
              :label-cols="2"
              :horizontal="true">
              <div>
                <b-button-group>
                  <b-button @click="statusChange()" :pressed="data.status=='publish'?true:false" size="sm" variant="outline-success">Publish</b-button>
                </b-button-group>
              </div>
            </b-form-group>

            <div>
            </div>
            <br>
            <br>
            <div slot="footer">
              <div class="form-row">
                <div class="col-sm-2">
                  
                </div>
                <div class="col-sm-8">
                  <b-button type="submit" size="sm" variant="primary" :disabled="isLoading" > Submit</b-button>
                  <b-button type="button" @click="goBack" size="sm" variant="danger" :disabled="isLoading">Back</b-button>
                </div>
              </div>

            </div>
          </b-form>
        </b-card>
      </b-col>
      
      <BlockUI message="loading" v-if="isLoading">
        <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
      </BlockUI>

    <b-modal title="Select Image" size="lg" class="modal-info" v-model="galeriesModal" @ok="galeriesModal =false" ok-variant="danger"  hide-footer hide-header>
      <G-modal @selectImage="selectImageModal"></G-modal>
    </b-modal>
  </b-row>
</template>

<script>

import  GaleriesModal from '../galery/GaleriesModal.vue';
import { VueEditor } from 'vue2-editor';
import VueTagsInput from '@johmun/vue-tags-input';
export default {
  name: 'Content',
  components: {
      VueEditor,
      VueTagsInput,
      'G-modal':GaleriesModal
   },
  props: {
    caption: {
      type: String,
      default: 'Content'
    },
  },
  
  mounted() {
    this.id = this.$route.params.id;
    if(this.id !== undefined){

      this.getCategory().then((e)=>{
        this.getData(this.id);
      });
    }else{
      this.getCategory();
    }
  },
  data: () => {
    return {
      error: false,
      galeriesModal: false,

      customToolbar: [

        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link", "image", "video"],
        ["clean"]
      ],
      data: {
        title: '',
        category_sub: '',
        img_prev: '',
        category: '',
        type:'article',
        status: 'publish',
        galery_id:'',
        video:'',
        galeries:[],
        tags:[],
      },
      options:{
        category:[],
        category_sub:[],
        type:[{name:'Picture',val:'article'},{name:'video',val:'video'}, {name:'galery',val:'galery'}]
      },
      image:'',
      file:'',
      uploadPercentage :0,
      msg : '',
      id:'',
      msg_type : '',
      isLoading:false,
    }
    
  },
  methods: {
    selectImage(){
      this.galeriesModal = true;
    },
    getCategorySub(evnt){
      var app = this;
      var find = this.options.category.filter(function(result) {
       return result.id === app.data.category;
       });
      if(this.data.category == 5 ){
        this.data.type = 'galery';
      }else{
        this.data.type = 'article';

      }
      //console.log(find);
      this.options.category_sub =find[0]==undefined? []:find[0].child;
      this.data.category_sub = '';
    },
    async getCategory(){
      var app = this;
      var url = this.end_point+'content_category';
      app.isLoading = true;
      axios.get(url, {})
        .then(function (resp) {
        app.isLoading=false;
        if(resp.data.error){
          app.$notify.error(resp.data.msg);
        }else{
          app.options.category = resp.data.data;
        }
      })
      .catch(function (resp) {
        console.log(resp);
        app.isLoading=false;
        // app.$notify.error(app.setting.msg_con);
        app.error = true;
      });  
    },
    getData(id){
      var app = this;
      var url = this.end_point+'content/'+id;
      app.isLoading = true;
      axios.get(url, {})
        .then(function (resp) {
        app.isLoading=false;
        if(resp.data.error){
          app.$notify.error(resp.data.msg);
        }else{
          app.data = resp.data.data;
          app.data.tag = '';

          var find = app.options.category.filter(function(result) {
           return result.id === app.data.category;
           });

          app.options.category_sub =find[0].child;
        }
      })
      .catch(function (resp) {
        console.log(resp);
        app.isLoading=false;
        // app.$notify.error(app.setting.msg_con);
        app.error = true;
      });  
    },
    submit() {
      var app = this;
      var newDt = app.data;
      var url = this.end_point;

      var api = '';
      if(this.id === undefined){
        url += 'content';
        api = axios.post(url, newDt);
      }else{
        url += 'content/'+this.id;
        api = axios.put(url, newDt);
      }
      app.isLoading=true;
      api
      .then(function (resp) {
        app.isLoading=false;
        if(resp.data.error){
          app.$notify.error(resp.data.msg);
          window.scrollTo(0,0);
        }else{
          app.$notify.success(resp.data.msg);
          app.$router.replace(`/content`);
        }
      })
      .catch(function (resp) {
        app.isLoading=false;
        app.$notify.error(app.setting.msg_con);
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    statusChange(){
      if(this.data.status=='publish'){
        this.data.status ='pending';
      }else{
        this.data.status ='publish';
      }
    },
    changeType(evnt){
      if(evnt == 'article'){
        this.data.video = '';
        this.data.galeries = [];
      }else
      if(evnt == 'video'){
        this.data.galery_id = '';
        this.data.img_prev = '';
        this.data.galeries = [];
      }else
      if(evnt == 'galery'){
        this.data.galery_id = '';
        this.data.img_prev = '';
        this.data.video = '';
        this.data.category = 5;
      }

        console.log(evnt)
    },
    submitFile(){
      let formData = new FormData();
      
      if(this.data.type == 'video'){
        this.submit();
        return;
      }
      if(this.data.type == 'article' &&( this.data.galery_id !='' && this.data.galery_id != undefined) ){
        this.submit();
        return;
      }

      if(this.data.type == 'article'){
        if(!this.file){
          this.$notify.error('please select image');
          return;
        }
        formData.append('file[]', this.file); 
      }

      if(this.data.type == 'galery'){
        if((this.data.galeries).length <=0){
          this.$notify.error('please select image');
          return;
        }
        let empty_file = [];
        for (var i = 0; i < this.data.galeries.length; i++) {
          if(this.data.galeries[i].file == null && this.data.galeries[i].galery_id !=0){
            empty_file.push(this.data.galeries[i].galery_id);
          }
          formData.append('file[]', this.data.galeries[i].file);
          formData.append('galery_id[]', this.data.galeries[i].galery_id); 
        }
        //console.log(this.data.galeries);
        //console.log(empty_file);
        if(empty_file.length == (this.data.galeries).length){
          this.data.galery_id = empty_file.join(',');
          this.submit();
          return false;
        }
      }
      formData.append('name', this.data.title);

      var app  = this;
      app.isLoading=true;
      axios.post( this.end_point+'content_upload',formData,{
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function( progressEvent ) {
          this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
        }.bind(this)
      }).then(function(e){
        
        app.isLoading=false;
        console.log(e);
        if(e.data.error){
          app.msg = e.data.msg;
          app.msg_type = 'danger';
          return false;
        }
        app.msg='';
        if(app.data.type == 'article'){     
          app.data.galery_id = e.data.data[0];  
        }
        if(app.data.type == 'galery'){     
          app.data.galery_id = (e.data.data).join(',');  
        }
        app.submit();     
        // app.createImage(app.file);
      })
      .catch(function(e){
          app.isLoading=false;
          app.msg = 'upload filed please try again';
          app.$notify.error(app.msg);
          app.msg_type = 'danger';
      });
    },
    onFileChange(e){
      this.image= '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length){      
          return;
      }
      this.file = files[0];
      this.data.galery_id = '';
      // this.submitFile();
      this.createImage(this.file);
    },
    removeGaleries(i){
      this.data.galeries.splice(i,1);
    },
    onFilesChange(e){
      this.image= '';
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length){      
          return;
      }
      for (var i = 0; i < files.length; i++) {
        var file = files[i]

        const image = new Image();
        const reader = new FileReader();
        //this.data.img_prev = null;

        const vm = this;
        reader.onload = e => {
          // vm.data.img_prev = reader.result;
          this.data.galeries.push({
            file:file,
            img_prev:reader.result,
            galery_id:0

          }); 
        };
        reader.readAsDataURL(file);
      }

    },
    createImage(file) {
      const FileSize = file.size / 1024 / 1024;
      console.log(FileSize, 'size');
      if (FileSize > 2) {
        //this.global.presentAlert('ukuran maksimal 2MB');
        //return false;
      }
      const image = new Image();
      const reader = new FileReader();
      //this.data.img_prev = null;

      const vm = this;
      reader.onload = e => {
        vm.data.img_prev = reader.result;
      };
      reader.readAsDataURL(file);

      this.file = file;
    },
    selectImageModal(item){
      //console.log(msg,' from child');
      this.galeriesModal = false;
      this.data.galery_id = item.id;
      this.data.img_prev = item.img;
    }
  }
}
</script>

<style>
.vue-tags-input{
  max-width:100% !important;
}
</style>
